import React from "react";

export default function Pagination({ data, setFilters, filters }) {
  return (
    <nav aria-label="Page navigation" className="mt-10">
      <p>
        Showing {data?.from} to {data?.to} of {data?.total} entries
      </p>
      <ul className="pagination pagination-sm">
        {data?.links?.map((btn, i) => (
          <li
            key={i}
            className={`page-item  ${btn?.active && "active"}  ${btn?.url ? "" : "disabled"
              } `}
          >
            <button
              className="page-link waves-effect"
              onClick={() => {
                if (data?.links?.length === i + 1) {
                  btn?.url &&
                    setFilters({
                      ...filters,
                      page: Number(data.current_page) + 1,
                    });
                } else if (i === 0) {
                  btn?.url &&
                    setFilters({
                      ...filters,
                      page: Number(data.current_page) - 1,
                    });
                } else {
                  setFilters({
                    ...filters,
                    page: Number(btn.label),
                  });
                }
              }}
            >
              {data?.links?.length === i + 1 ? (
                <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
              ) : i === 0 ? (
                <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
              ) : (
                btn?.label
              )}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
